<article>
  <div class="title-pill text">WHO ARE WE?</div>
  <p class="text about">
    Pixel Pro is a start up with humble beginnings ready to change, grow and
    emerge a pioneer in the software development industry. We take pride in our
    youth and curiosity, but most of all in our outside the box approach. With
    our range of products, we believe we have managed to take old ideas, and
    spin it to something that can completely sweep the industry. The founding
    members, Yewo Theu and Abel Tshimbalanga were raised in a small village in
    Botswana called Thamaga, setting up shop in the place they knew most. They
    started off in early April 2018, and realized, that their combined skills of
    software development and their immersive understanding of what the market
    demanded, gave them a unique edge. Their agendum? To create a product that
    puts people back on the edge of their seats. To put back power in their
    clients hands. To make a solution that lifts you, outside the box.
  </p>
</article>
<article>
  <div class="title-pill text">MEET THE TEAM...</div>
  <div class="team-section">
    <div class="team-member">
      <img class="member-img" src="../../assets/images/team-1.jpeg" />
      <h4 class="text">Yewo Theu</h4>
      <span class="text">Chief Innovation & Resources Officer</span>
    </div>
    <div class="team-member">
      <img class="member-img" src="../../assets/images/team-2.png" />
      <h4 class="text">Bernard Sebakile</h4>
      <span class="text">Business Relations & Compliance Manager</span>
    </div>
    <div class="team-member">
      <img class="member-img" src="../../assets/images/team-3.png" />
      <h4 class="text">Abel Tshimbalanga</h4>
      <span class="text">Chief Operations & Risk Officer</span>
    </div>
  </div>
</article>
<article>
  <div class="title-pill text">HEAR OUR VOICE!</div>
  <p class="text about">
    🎙️ Catch our interview on First Issues!
    We share the story behind our business and our flagship product — 
    Smart Restaurant Suite (SRS) — designed to transform how restaurants operate.
       
   If you're into tech, entrepreneurship, or innovation in hospitality, or just 
   love hearing about innovative local solutions making real impact — 
   this one's for you 🎯
  </p>
  <section class="interview-section">
    <iframe class="videoplayer"
        src="https://www.youtube.com/embed/K1I458Xn4H4"
        title="Our interview"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen>
      </iframe>
  </section>
  
</article>